import { CreateReportParams } from '@/pages/evaluation/create-modal'
import { request } from './request'
// 获取任务列表
export interface GetReportListData {
  limit: number
  page: number
  name?: string
  start_time?: string
  end_time?: string
  status?: number | undefined
  campaign_type: number
}
export const getReportList = (data: GetReportListData) =>
  request('/portal/report/campaign/task/list', {
    params: {
      ...data,
    },
  })
// 删除报表
export interface DeleteReportData {
  id: string | string[]
}
export const deleteReport = (data: DeleteReportData) =>
  request('/portal/report/campaign/task', {
    method: 'delete',
    params: { ...data },
  })
//获取任务列表
export interface GetTaskOptionData {
  campaign_type: number
  second_type?: number
}
export const getTaskOption = (data: GetTaskOptionData) =>
  request('/portal/report/campaign/task/option', {
    params: {
      ...data,
    },
  })

// 获取剧本执行列表
export const getScenariosExecutions = () =>
  request('/portal/v1/orchestration/report/scenarios/executions')

// 添加报表
export interface AddReportData {
  report_name: string
  campaign_type: number
  template_type: number[]
  task_list: TaskList[]
  assets: number
  emails: string
  [property: string]: any
}

export interface TaskList {
  /**
   * 任务详情id
   */
  campaign_id: string
  /**
   * 任务名称
   */
  task_name: string
  [property: string]: any
}
export const addReport = (data: CreateReportParams) =>
  request('/portal/report/campaign/task', {
    method: 'post',
    data,
  })

// 下载报表
export interface DownloadReportData {
  id: string | string[]
}
export const downloadReport = (data: DownloadReportData) =>
  request('/portal/report/campaign/task/download', {
    method: 'post',
    responseType: 'blob',
    data,
  })

export interface ViewReportData {
  id: string
  user_id?: string
}
export const viewReport = (data: ViewReportData) =>
  request('/portal/report/campaign/task/look', {
    method: 'post',
    responseType: 'arraybuffer',
    data,
  })
//获取报表类型与模板类型列表
export const getMenu = () => request('/portal/report/campaign/menu')
// 获取下载报表地址
export const wsUrl = () => request('/portal/report/ws_url')
